import React from 'react';
import t from '@guestyci/localize/t.macro';
import { Circle, CircleCheck, CircleX } from '@guestyci/icons/system';
import { parseOktaRequirements } from '../../utils/parseOktaRequirements';

const buildEmailNameRules = (emailLocal, firstName, lastName, includeEmail, includeFirstName, includeLastName) => {
  const rules = [];

  if (includeEmail) {
    rules.push({
      key: 'noEmail',
      label: t('Cannot contain your email address'),
      validate: pw => !emailLocal || !pw.toLowerCase().includes(emailLocal),
      alwaysVerifiable: !!emailLocal,
      canVerify: !!emailLocal,
    });
  }

  if (includeFirstName) {
    rules.push({
      key: 'noFirstName',
      label: t('Cannot contain your first name'),
      validate: pw => !firstName || !pw.toLowerCase().includes(firstName),
      alwaysVerifiable: !!firstName,
      canVerify: !!firstName,
    });
  }

  if (includeLastName) {
    rules.push({
      key: 'noLastName',
      label: t('Cannot contain your last name'),
      validate: pw => !lastName || !pw.toLowerCase().includes(lastName),
      alwaysVerifiable: !!lastName,
      canVerify: !!lastName,
    });
  }

  return rules;
};

const RuleItem = ({ label, isMet, isRed }) => {
  const textClass = isMet ? 'gst-text-success' : isRed ? 'gst-text-destructive' : 'gst-text-muted-foreground';
  const iconClass = `gst-h-4 gst-w-4 gst-shrink-0 ${textClass}`;

  return (
    <div className="gst-flex gst-items-center gst-gap-1.5">
      {isMet ? (
        <CircleCheck className={iconClass} />
      ) : isRed ? (
        <CircleX className={iconClass} />
      ) : (
        <Circle className={iconClass} />
      )}
      <span className={`gst-text-sm ${textClass}`}>{label}</span>
    </div>
  );
};

const ValidationRules = ({ password = '', email = '', firstName = '', lastName = '', submitted = false, oktaRequirements = [] }) => {
  const emailLocal = email ? email.toLowerCase().split('@')[0] : '';
  const firstNameLower = firstName ? firstName.toLowerCase() : '';
  const lastNameLower = lastName ? lastName.toLowerCase() : '';
  const hasContent = password.length > 0;
  const baseRules = parseOktaRequirements(oktaRequirements);

  const includeEmail = oktaRequirements.includes('noEmail') && !!emailLocal;
  const includeFirstName = oktaRequirements.includes('noFirstName') && !!firstNameLower;
  const includeLastName = oktaRequirements.includes('noLastName') && !!lastNameLower;
  const emailNameRules = buildEmailNameRules(emailLocal, firstNameLower, lastNameLower, includeEmail, includeFirstName, includeLastName);
  const allRules = [...baseRules, ...emailNameRules];

  return (
    <div className="gst-space-y-2">
      {allRules.map(({ key, label, validate, alwaysVerifiable, canVerify }) => {
        const isMet = hasContent && validate ? validate(password) : false;
        const isRed = submitted && !isMet && (alwaysVerifiable || (canVerify && hasContent));

        return (
          <RuleItem key={key} label={label} isMet={isMet} isRed={isRed} />
        );
      })}
    </div>
  );
};

export default ValidationRules;
